/* Mystery-Armband: Fortschrittsanzeige im Warenkorb (Drawer + Warenkorbseite) und Auswahl auf der Produktseite – alles nach aktuellem Warenkorbwert */
(function () {
  var C = window.LuxGift;
  if (!C) return;
  var T = C.t;
  var TH = C.threshold;
  var VID = C.variantId;
  var EX = C.exclude || [];
  var R = window.routes || {};
  var ADD = (R.cart_add_url || '/cart/add') + '.js';
  var CHANGE = (R.cart_change_url || '/cart/change') + '.js';
  var CART = (R.cart_url || '/cart') + '.js';
  var lastHtml = '';
  var busy = false;
  var timer = null;
  var onCartPage = /\/cart\/?$/.test(location.pathname);

  var css = '.lg{margin:0 0 1.2rem;padding:1rem 1.2rem 1.1rem;border:1px solid rgba(0,0,0,.13);border-radius:.4rem;background:rgba(0,0,0,.024);color:#000;font-family:Helvetica,Arial,sans-serif;letter-spacing:0}' +
    '.drawer__inner .lg{margin:0 0 1rem}' +
    '.lg__top{display:flex;align-items:center;gap:.8rem}' +
    '.lg__ic{width:1.8rem;height:1.8rem;flex:none;display:block}' +
    '.lg__ic svg{width:100%;height:100%;display:block}' +
    '.lg__t{flex:1;min-width:0;margin:0;font-size:1.3rem;line-height:1.3;font-weight:500}' +
    '.lg__t strong{font-weight:700}' +
    '.lg__amt{font-size:1.1rem;color:rgba(0,0,0,.5);font-variant-numeric:tabular-nums;white-space:nowrap}' +
    '.lg__bar{height:.5rem;margin-top:.7rem;background:rgba(0,0,0,.08);border-radius:1rem;overflow:hidden}' +
    '.lg__bar span{display:block;height:100%;background:#00b67a;border-radius:1rem;transition:width .5s ease}' +
    '.lg__btn{display:block;margin-top:1rem;width:100%;min-height:4.2rem;border:0;border-radius:.4rem;background:#000;color:#fff;font-size:1.2rem;font-weight:700;letter-spacing:.05em;text-transform:uppercase;cursor:pointer;font-family:inherit}' +
    '.lg__btn:hover{background:#222}' +
    '.lg__btn[disabled]{opacity:.6;cursor:default}' +
    '.lg.is-done{border-color:#00b67a;background:rgba(0,182,122,.06)}' +
    '.lg.is-done .lg__amt{color:#00b67a;font-weight:700}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8" width="17" height="4" rx=".5"/><path d="M5 12v8h14v-8M12 8v12M12 8c-1.5-3.5-5-3.5-5-1.25C7 8 9.5 8 12 8zm0 0c1.5-3.5 5-3.5 5-1.25C17 8 14.5 8 12 8z"/></svg>';

  function money(c) {
    try {
      return new Intl.NumberFormat(C.locale || 'fr', { style: 'currency', currency: C.currency || 'EUR' }).format(c / 100);
    } catch (e) {
      return (c / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }
  function isGift(i) { return VID && i.variant_id === VID; }
  function counts(i) { return !isGift(i) && EX.indexOf(i.handle) === -1; }
  function eligible(cart) {
    return cart.items.reduce(function (s, i) { return counts(i) ? s + i.final_line_price : s; }, 0);
  }
  function giftLine(cart) {
    for (var k = 0; k < cart.items.length; k++) if (isGift(cart.items[k])) return cart.items[k];
    return null;
  }
  function titleFor(tot, has) {
    if (tot >= TH) return has ? T.added : T.unlocked;
    return T.missing.replace('[x]', '<strong>' + money(TH - tot) + '</strong>');
  }

  /* ---------- Warenkorb (Drawer + Seite) ---------- */
  function build(cart) {
    if (!cart || !cart.item_count) return '';
    var tot = eligible(cart);
    if (tot <= 0) return '';
    var done = tot >= TH;
    var pct = done ? 100 : Math.max(3, Math.floor((tot * 100) / TH));
    var has = !!giftLine(cart);
    var amt = done ? '100 %' : money(tot) + ' / ' + money(TH);
    var btn = done && !has && VID ? '<button type="button" class="lg__btn" data-lux-gift-add>' + T.choose + '</button>' : '';
    return '<div class="lg__top" data-done="' + (done ? 1 : 0) + '"><span class="lg__ic">' + ICON + '</span><p class="lg__t">' + titleFor(tot, has) + '</p><span class="lg__amt">' + amt + '</span></div>' +
      '<div class="lg__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>' + btn;
  }

  function targets() {
    var out = [];
    var head = document.querySelector('#CartDrawer .drawer__header');
    if (head) out.push({ ref: head, pos: 'afterend' });
    var form = document.querySelector('cart-items form#cart');
    if (form) out.push({ ref: form, pos: 'beforebegin' });
    return out;
  }

  function paint(html) {
    targets().forEach(function (t) {
      var host = t.pos === 'afterend' ? t.ref.nextElementSibling : t.ref.previousElementSibling;
      if (!host || !host.hasAttribute('data-lux-gift-bar')) {
        host = document.createElement('div');
        host.setAttribute('data-lux-gift-bar', '');
        host.hidden = true;
        t.ref.insertAdjacentElement(t.pos, host);
      }
      if (host.getAttribute('data-html') !== html) {
        host.setAttribute('data-html', html);
        host.innerHTML = html;
        host.className = html ? 'lg' + (html.indexOf('data-done="1"') > -1 ? ' is-done' : '') : '';
        host.hidden = !html;
      }
    });
  }

  /* ---------- Produktseite: Block live nach Warenkorbwert aktualisieren ---------- */
  function syncPdp(cart) {
    var tot = eligible(cart);
    var done = tot >= TH;
    var has = !!giftLine(cart);
    var pct = done ? 100 : Math.floor((tot * 100) / TH);
    document.querySelectorAll('[data-lux-gift-pdp]').forEach(function (box) {
      box.classList.toggle('is-done', done);
      var t = box.querySelector('[data-lux-gift-title]');
      if (t) t.innerHTML = titleFor(tot, has);
      var p = box.querySelector('[data-lux-gift-pct]');
      if (p) p.textContent = pct + '%';
      var f = box.querySelector('[data-lux-gift-fill]');
      if (f) {
        f.style.width = pct + '%';
        f.parentNode.setAttribute('aria-valuenow', pct);
      }
      var card = box.querySelector('.lp-mys');
      if (!card) return;
      card.classList.toggle('is-in', has);
      card.classList.toggle('is-open', done && !has);
      card.classList.toggle('is-locked', !done && !has);
      var sub = card.querySelector('[data-lux-gift-sub]');
      if (sub) {
        sub.innerHTML = done || has
          ? (card.getAttribute('data-value') ? '<s>' + card.getAttribute('data-value') + '</s> ' : '') + '<b class="lp-mys__free">' + T.free + '</b>'
          : T.locked;
      }
      var act = card.querySelector('[data-lux-gift-action]');
      if (act) {
        var h = has ? '<span class="lp-mys__state">' + T.inCart + '</span>'
          : done && VID ? '<button type="button" class="lp-mys__btn" data-lux-gift-add>' + T.chooseShort + '</button>' : '';
        if (act.getAttribute('data-h') !== h) {
          act.setAttribute('data-h', h);
          act.innerHTML = h;
        }
      }
    });
  }

  function getCart() {
    return fetch(CART, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function refreshDrawer(open) {
    if (onCartPage) { location.reload(); return Promise.resolve(); }
    var d = document.querySelector('cart-drawer');
    if (!d) return Promise.resolve();
    return fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parse = function (h, sel) { return h ? new DOMParser().parseFromString(h, 'text/html').querySelector(sel) : null; };
        var inner = parse(s['cart-drawer'], '#CartDrawer');
        var box = document.getElementById('CartDrawer');
        if (inner && box) box.innerHTML = inner.innerHTML;
        var bub = document.getElementById('cart-icon-bubble');
        var b = parse(s['cart-icon-bubble'], '.shopify-section');
        if (bub && b) bub.innerHTML = b.innerHTML;
        var empty = !!document.querySelector('#CartDrawer .drawer__inner-empty');
        d.classList.toggle('is-empty', empty);
        var ov = document.getElementById('CartDrawer-Overlay');
        if (ov && d.close) ov.addEventListener('click', d.close.bind(d));
        if (open && d.open && !d.classList.contains('active')) d.open();
      });
  }

  function addGift(open) {
    if (!VID || busy) return Promise.resolve();
    busy = true;
    return fetch(ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: VID, quantity: 1 }] })
    })
      .then(function () { return refreshDrawer(open); })
      .finally(function () { busy = false; refresh(); });
  }

  /* Gratis-Armband entfernen, wenn der Warenkorbwert unter die Schwelle fällt; max. 1 Stück */
  function sanitize(cart) {
    var g = giftLine(cart);
    if (!g || busy) return;
    var want = eligible(cart) >= TH ? 1 : 0;
    if (g.quantity === want) return;
    busy = true;
    fetch(CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: g.key, quantity: want })
    })
      .then(function () { return refreshDrawer(false); })
      .finally(function () { busy = false; refresh(); });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      getCart().then(function (cart) {
        lastHtml = build(cart);
        paint(lastHtml);
        syncPdp(cart);
        sanitize(cart);
      }).catch(function () {});
    }, 120);
  }
  window.LuxGift.refresh = refresh;

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-lux-gift-add]');
    if (!add || add.disabled) return;
    e.preventDefault();
    add.disabled = true;
    add.textContent = T.adding;
    var act = add.closest('[data-lux-gift-action]');
    if (act) act.setAttribute('data-h', '');
    addGift(true);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
  }

  /* Drawer & Warenkorbseite werden von Dawn neu gerendert – Leiste danach wieder einsetzen und aktualisieren */
  function ours(m) {
    var t = m.target;
    if (t && t.closest && t.closest('[data-lux-gift-bar]')) return true;
    var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
    return nodes.length > 0 && nodes.every(function (n) { return n.nodeType === 1 && n.hasAttribute('data-lux-gift-bar'); });
  }
  var mo = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (!ours(list[i])) {
        if (lastHtml) paint(lastHtml);
        refresh();
        return;
      }
    }
  });
  var cd = document.getElementById('CartDrawer');
  if (cd) mo.observe(cd, { childList: true, subtree: true });
  var ci = document.querySelector('cart-items');
  if (ci) mo.observe(ci, { childList: true, subtree: true });

  refresh();
})();
